import { useCallback, useState } from "react";
import saleReopenService from "../services/sale-reopen-service.js";

/**
 * Hook fino do fluxo request/approve/reject de reabertura de venda.
 */
export function useSaleReopen() {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const run = useCallback(async (fn) => {
    setLoading(true);
    setError(null);
    try {
      const response = await fn();
      if (!response?.success) {
        setError(response?.message || "Erro inesperado");
      }
      return response;
    } catch (err) {
      const message = err?.message || "Erro inesperado";
      setError(message);
      return {
        success: false,
        message,
        status: 500,
        code: "UNKNOWN_ERROR",
        error: err,
      };
    } finally {
      setLoading(false);
    }
  }, []);

  const loadRecipientSelectionOptions = useCallback(
    (role, requestOptions) =>
      run(() =>
        saleReopenService.getRecipientSelectionOptions(role, requestOptions),
      ),
    [run],
  );

  const requestReopen = useCallback(
    (idsale, body, requestOptions) =>
      run(() => saleReopenService.requestReopen(idsale, body, requestOptions)),
    [run],
  );

  const approveReopen = useCallback(
    (idsale, body, requestOptions) =>
      run(() => saleReopenService.approveReopen(idsale, body, requestOptions)),
    [run],
  );

  const rejectReopen = useCallback(
    (idsale, body, requestOptions) =>
      run(() => saleReopenService.rejectReopen(idsale, body, requestOptions)),
    [run],
  );

  return {
    loading,
    error,
    loadRecipientSelectionOptions,
    requestReopen,
    approveReopen,
    rejectReopen,
  };
}
